// Live order schedule (matches the shipping policy). Recomputes every ship
// date and the cutoff countdown in the visitor's browser from theme settings,
// in the roastery's time zone, so cached pages never show a stale date.
const configEl = document.getElementById('ogni-roast-config');
const config = configEl ? JSON.parse(configEl.textContent) : null;
const DAY = 86400000;

// Wall-clock "now" in the roastery's time zone, expressed as UTC ms.
const roasteryNow = (tz) => {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short',
    }).formatToParts(new Date()).map((p) => [p.type, p.value]),
  );
  const ms = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
  const weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(parts.weekday) + 1;
  return { ms, weekday };
};

const schedule = () => {
  const { ms, weekday } = roasteryNow(config.timeZone);
  const midnight = ms - (ms % DAY);
  let days = (config.cutoffDay - weekday + 7) % 7;
  let cutoff = midnight + days * DAY + config.cutoffHour * 3600000;
  if (cutoff <= ms) cutoff += 7 * DAY;
  const cutoffMidnight = cutoff - (cutoff % DAY);
  let shipGap = (config.shipDay - config.cutoffDay + 7) % 7;
  if (shipGap === 0) shipGap = 7;
  return { cutoff: cutoffMidnight, ship: cutoffMidnight + shipGap * DAY, remaining: cutoff - ms };
};

const format = (utcMs, style) =>
  new Intl.DateTimeFormat(config.locale || 'en', {
    timeZone: 'UTC',
    ...(style === 'weekday' ? { weekday: 'long' }
      : style === 'short' ? { weekday: 'short', month: 'short', day: 'numeric' }
      : { weekday: 'long', month: 'short', day: 'numeric' }),
  }).format(new Date(utcMs));

const update = () => {
  if (!config) return;
  const s = schedule();
  document.querySelectorAll('[data-ogni-date]').forEach((el) => {
    el.textContent = format(el.dataset.ogniDate === 'cutoff' ? s.cutoff : s.ship, el.dataset.style);
  });
  // Calm, rounded wording: "2 days", "5 hours", "40 minutes".
  const mins = Math.max(1, Math.round(s.remaining / 60000));
  const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;
  const left = mins >= 1440 * 2 ? plural(Math.floor(mins / 1440), 'day')
    : mins >= 120 ? plural(Math.round(mins / 60), 'hour')
    : plural(mins, 'minute');
  document.querySelectorAll('[data-ogni-countdown]').forEach((el) => {
    el.textContent = config.within.replace('%TIME%', left).replace('%SHIP%', format(s.ship, 'full'));
  });
};

window.ogniRoastUpdate = update;
update();
setInterval(update, 30000);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) update();
});
